import { render, staticRenderFns } from "./my_sound.vue?vue&type=template&id=305ca9a7&scoped=true&"
import script from "./my_sound.vue?vue&type=script&lang=js&"
export * from "./my_sound.vue?vue&type=script&lang=js&"
import style0 from "./my_sound.vue?vue&type=style&index=0&id=305ca9a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305ca9a7",
  null
  
)

export default component.exports